import { api } from "./api"

export const GET_ALL_ENTITIES = async () => {
    const {data} = await api.get("/entities/all")
    return data.entities || [];
}

export const GET_ENTITY_DATA = async (id: string) => {
    const {data} = await api.get(`/entities/${id}/details`)
    return data.entity;
}

export const SAVE_ENTITY_KEYWORDS = async (id: string, keywords: string[]) => {
    const {data} = await api.patch(`/entities/${id}`, {keywords})
    return data.entity;
}

export const UPDATE_ENTITY_IMAGE = async (id: string, image: string) => {
    const {data} = await api.patch(`/entities/${id}/image`, {image})
    return data.entity;
}
